import React, { useState } from 'react';
import './HRPHistory.css';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import { InterfaceHRPData } from '../../beneficiary.interface';
import AntDateFieldsComponent from '@components/common/AntDatePickerFields';
import dayjs from 'dayjs';
import SearchableDropdownComponent from '@components/common/SearchableDropDown';
import { RoutineANCCondition } from '@utils/hrpConditionCheck';

import config from '@config/config';
import { isValidOneToEighteenWithDecimal } from '@utils/commonUtils';
import { COMMON_CONSTANTS } from '@constants/index';
import Slider from '@components/common/Slider';
import { useServiceRuleValue } from '@hooks/useServiceRuleMaster';

interface IProps {
  hrpServiceData: any;
  disableOptions?: any;
  selectedHRp: any;
  hrpType: string;
  setFormData: any;
  formData: any;
}

const initData: any = {};
const AllHRPForms = ({
  hrpServiceData,
  disableOptions,
  selectedHRp,
  hrpType,
  setFormData,
  formData = initData,
}: IProps) => {

  const bpSystolic = useServiceRuleValue('hrp-rules', 'bp_systolic_mm_hg_bp_systolic_mm_hg__hypertension_systolic_gteq_140_mm_hg.value', config.bpSystolic);
  const bpDiastolic = useServiceRuleValue('hrp-rules', 'bp_diastolic_mm_hg_bp_diastolic_mm_hg__hypertension_systolic_gteq_140_mm_hg.value', config.bpDiastolic);
  const bpSystolicMin = useServiceRuleValue('hrp-rules', 'bp_systolic_mm_hg_min.value', config.bpSystolicMin);
  const bpSystolicMax = useServiceRuleValue('hrp-rules', 'bp_systolic_mm_hg_max.value', config.bpSystolicMax);
  const bpDiastolicMin = useServiceRuleValue('hrp-rules', 'bp_diastolic_mm_hg_min.value', config.bpDiastolicMin);
  const bpDiastolicMax = useServiceRuleValue('hrp-rules', 'bp_diastolic_mm_hg_max.value', config.bpDiastolicMax);

  const [isErrSystolic, setIsErrSystolic] = useState<boolean>(false);
  const [errMessageSystolic, setErrMessageSystolic] = useState<string>('');
  const [errMessageDiastolic, setErrMessageDiastolic] = useState<string>('');
  const [isErrDiastolic, setIsErrDiastolic] = useState<boolean>(false);

  const handleInput = (
    name: string,
    value: any,
    selectionType: any,
  ) => {
    const newFrom: any = { ...formData };
    if (selectionType === 'multiple') {
      newFrom[name].value = newFrom[name].dropDownoption.filter((ele: any) =>
        value.includes(ele.value),
      );
    } else {
      newFrom[name].value = value;
      if (name == "bp_systolic_mm_hg") {
        value = parseInt(value);
        if (value < bpSystolicMin || value > bpSystolicMax) {
          setIsErrSystolic(true);
          setErrMessageSystolic(`BP Systolic must be between ${bpSystolicMin} and ${bpSystolicMax} mm.`);
        } else if (value < bpSystolic && value >= bpSystolicMin) {
          setIsErrSystolic(true);
          setErrMessageSystolic(`BP Systolic should be above ${bpSystolic} for HRP`);
        } else {
          setIsErrSystolic(false);
          setErrMessageSystolic('');
        }
      
        if (value <= parseInt(formData.bp_diastolic_mm_hg.value)) {
          setIsErrDiastolic(true);
          setErrMessageDiastolic('BP Systolic must be greater than BP Diastolic.');
        } else {
          setIsErrDiastolic(false);
          setErrMessageDiastolic('');
        }
      } else if (name == "bp_diastolic_mm_hg") {
        value = parseInt(value);
        if (value < bpDiastolicMin || value > bpDiastolicMax) {
          setIsErrDiastolic(true);
          setErrMessageDiastolic(`BP Diastolic must be between ${bpDiastolicMin} and ${bpDiastolicMax} mm.`);
        } else if (parseInt(formData.bp_systolic_mm_hg.value) <= value) {
          setIsErrDiastolic(true);
          setErrMessageDiastolic('BP Systolic must be greater than BP Diastolic.');
        } else if (value < bpDiastolic && value >= bpDiastolicMin) {
          setIsErrDiastolic(true);
          setErrMessageDiastolic(`BP Diastolic should be above ${bpDiastolic} for HRP`);
        } else {
          setIsErrDiastolic(false);
          setErrMessageDiastolic('');
        }
      } else if (name == COMMON_CONSTANTS.HB_GM && !isValidOneToEighteenWithDecimal(value)) {
        return;
      }
    }

    setFormData(newFrom);
  };


  const hypertensionForm = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          {/* <InputFieldsComponent
            labelName={formData?.bp_systolic_mm_hg?.labelName}
            placeholder={'Type Here'}
            type={'text'}
            isDisabled={false}
            inputType={isErrSystolic ? 'error' : 'general'}
            errorMessage={errMessageSystolic}
            onChange={(value: any) =>
              handleInput('bp_systolic_mm_hg', value, '')
            }
            required={true}
            value={formData?.bp_systolic_mm_hg?.value}
          />
          <InputFieldsComponent
            labelName={formData?.bp_diastolic_mm_hg?.labelName}
            placeholder={'Type Here'}
            type={'text'}
            isDisabled={false}
            inputType={isErrDiastolic ? 'error' : 'general'}
            errorMessage={errMessageDiastolic}
            onChange={(value: any) =>
              handleInput('bp_diastolic_mm_hg', value, '')
            }
            required={true}
            value={formData?.bp_diastolic_mm_hg?.value}
          /> */}
          <Slider
            label={formData?.bp_systolic_mm_hg?.labelName}
            min={40}
            max={400}
            defaultValue={40}
            smallStep={1}
            largeStep={10}
            onChange={(value: number) => (handleInput('bp_systolic_mm_hg', value, ''))}
            inputType={isErrSystolic ? 'error' : 'general'}
            errorMessage={errMessageSystolic}
          />
          <Slider
            label={formData?.bp_diastolic_mm_hg?.labelName}
            min={30}
            max={300}
            defaultValue={30}
            smallStep={1}
            largeStep={10}
            onChange={(value: number) => (handleInput('bp_diastolic_mm_hg', value, ''))}
            inputType={isErrDiastolic ? 'error' : 'general'}
            errorMessage={errMessageDiastolic}
          />
        </div>
      </div>
    </div>
  );

  const severeAnemiaForm = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          {/* <InputFieldsComponent
            labelName={formData?.hb_gm?.labelName}
            placeholder={'Type Here'}
            type={'text'}
            isDisabled={false}
            onChange={(value: any) => handleInput('hb_gm', value, '')}
            required={true}
            value={formData?.hb_gm?.value}
          /> */}
          <Slider
            label={formData?.hb_gm?.labelName}
            min={1}
            max={18}
            defaultValue={1}
            smallStep={0.1}
            largeStep={1.0}
            onChange={(value: number) => (handleInput('hb_gm', value, ''))}
          />
          <SearchableDropdownComponent
            options={formData?.severe_anaemia_treatment?.dropDownoption}
            disableOptions={disableOptions}
            onChange={(data: any) => {
              handleInput(
                'severe_anaemia_treatment',
                data,
                formData?.isMultiple ? 'multiple' : 'single'
              );
            }}
            placeHolder={formData?.severe_anaemia_treatment?.labelName}
            multipleSelection={formData?.severe_anaemia_treatment?.isMultiple}
            dropLabelName={formData?.severe_anaemia_treatment?.labelName}
            ifRequired={true}
            dropDownDisable={
              formData?.hb_gm?.value &&
                RoutineANCCondition('hb', formData?.hb_gm?.value)
                ? false
                : true
            }
            dropdownsearchable={true}
            value={formData?.severe_anaemia_treatment?.value}
            isClearable={true}
          />

        </div>
      </div>
    </div>
  );

  const singleDisableDropDownAndDateForms = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          <SearchableDropdownComponent
            options={formData?.selectedHrp?.dropDownoption}
            disableOptions={disableOptions}
            onChange={() => { }}
            placeHolder={formData?.selectedHrp?.lableName}
            multipleSelection={false}
            dropLabelName={formData?.selectedHrp?.lableName}
            ifRequired={true}
            dropDownDisable={true}
            dropdownsearchable={true}
            value={formData?.selectedHrp?.value}
            isClearable={false}
          />
          {(formData?.showDateField && formData?.showDateField?.showDateField) && (
            <AntDateFieldsComponent
              placeholder={'Type Here'}
              onChange={(changedData) =>
                handleInput('showDateField', dayjs(changedData).format('YYYY-MM-DD'), '')
              }
              labelName="Date of Test"
              isDisabled={false}
              type="date"
              required={false}
              value={formData?.showDateField?.value}
              maxDate={dayjs(new Date()).format('YYYY-MM-DD')}
              minDate="2000-01-01"
            />
          )}
        </div>
      </div>
    </div>
  );

  const fetalMalpresentationeAndBloodGroupForms = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          <SearchableDropdownComponent
            options={formData?.selectedHrp?.dropDownoption}
            disableOptions={disableOptions}
            onChange={(data: any) => {
              handleInput(
                'selectedHrp',
                data,
                formData?.selectedHrp?.isMultiple ? 'multiple' : 'single'
              );
            }}
            placeHolder={formData?.selectedHrp?.lableName}
            multipleSelection={formData?.selectedHrp?.isMultiple}
            dropLabelName={formData?.selectedHrp?.lableName}
            ifRequired={true}
            dropDownDisable={false}
            dropdownsearchable={true}
            value={formData?.selectedHrp?.value}
            isClearable={true}
          />
        </div>
      </div>
    </div>
  );

  const gestationalDiabetesMellitusForms = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          <SearchableDropdownComponent
            options={formData?.selectedHrp?.dropDownoption}
            disableOptions={disableOptions}
            onChange={(data: any) => {
              handleInput(
                'selectedHrp',
                data,
                formData?.selectedHrp?.isMultiple ? 'multiple' : 'single'
              );
            }}
            placeHolder={formData?.selectedHrp?.lableName}
            multipleSelection={formData?.selectedHrp?.isMultiple}
            dropLabelName={formData?.selectedHrp?.lableName}
            ifRequired={true}
            dropDownDisable={false}
            dropdownsearchable={true}
            value={formData?.selectedHrp?.value}
            isClearable={true}
          />
          <AntDateFieldsComponent
            placeholder={'Type Here'}
            onChange={(changedData) =>
              handleInput('showDateField', dayjs(changedData).format('YYYY-MM-DD'), '')
            }
            labelName="Date of Test"
            isDisabled={false}
            type="date"
            required={false}
            value={formData?.showDateField?.value}
            maxDate={dayjs(new Date()).format('YYYY-MM-DD')}
            minDate="2000-01-01"
          />
        </div>
      </div>
    </div>
  );

  const underWeightAndHeightForm = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          <InputFieldsComponent
            labelName={formData?.weight_in_kg?.labelName}
            placeholder={'Type Here'}
            type={'text'}
            isDisabled={false}
            onChange={(value: any) =>
              handleInput('weight_in_kg', value, '')
            }
            required={true}
            value={formData?.weight_in_kg?.value}
          />
        </div>
      </div>
    </div>
  );

  const shortStatureForm = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <div className="demographic_input_fields">
          <InputFieldsComponent
            labelName={formData?.height_in_cm?.labelName}
            placeholder={'Type Here'}
            type={'text'}
            isDisabled={false}
            onChange={(value: any) =>
              handleInput('height_in_cm', value, '')
            }
            required={true}
            value={formData?.height_in_cm?.value}
          />
        </div>
      </div>
    </div>
  );

  const otherForms = (
    <div className="demographic_container">
      <div className="demographic_id_container">
        <h4 className="demographic_headings">{hrpType}</h4>
        <hr />
        <div className="demographic_input_fields">
          <InputFieldsComponent
            labelName="Other High Risk symtom"
            type={'text'}
            isDisabled={true}
            placeholder={''}
            onChange={() => { }}
            required={true}
            value={hrpType}
          />
        </div>
      </div>
    </div>
  );

  const checkHrpTyp = (hrpType: string) => {
    switch (hrpType) {
      case 'Hypertension':
        return hypertensionForm;
        break;
      case 'Severe Anaemia':
        return severeAnemiaForm;
        break;
      case 'TB':
        return singleDisableDropDownAndDateForms;
        break;
      case 'Hypothyroidism':
        return singleDisableDropDownAndDateForms;
        break;
      case 'Hep - B':
        return singleDisableDropDownAndDateForms;
        break;
      case 'HIV':
        return singleDisableDropDownAndDateForms;
        break;
      case 'Syphilis':
        return singleDisableDropDownAndDateForms;
        break;
      case 'Malaria':
        return singleDisableDropDownAndDateForms;
        break;
      case 'Fetal Malpresentation':
        return fetalMalpresentationeAndBloodGroupForms;
        break;
      case 'Rh Negative Blood Group':
        return fetalMalpresentationeAndBloodGroupForms;
        break;
      case 'Other High Risk Symptoms':
        return fetalMalpresentationeAndBloodGroupForms;
        break;
      case 'Obstetric History':
        return fetalMalpresentationeAndBloodGroupForms;
        break;
      case 'Gestational Diabetes Mellitus':
        return gestationalDiabetesMellitusForms;
        break;
      case 'Underweight':
        return underWeightAndHeightForm;
        break;
      case 'Short Stature':
        return shortStatureForm;
        break;

      default:
        otherForms
        break;
    }
  };

  return (
    <>
      {checkHrpTyp(hrpType)}
    </>
  );
};
export default AllHRPForms;
